// extracted by mini-css-extract-plugin
export default {"container":"smallLabel_container__RHtG3","icon":"smallLabel_icon__ZEFS1","labelFont":"smallLabel_labelFont__XpHGT"};